import { useParams } from 'react-router-dom';
import PageShell from '../components/PageShell';
import AppEmbedFrame from '../components/AppEmbedFrame';
import OpenInAppButton from '../components/OpenInAppButton';
import { getEmbedConfigByRoute } from '../lib/embedConfig';

function EmbedApp() {
  const { appKey } = useParams<{ appKey: string }>();
  const config = getEmbedConfigByRoute(`/embed/${appKey ?? ''}`);

  if (!config) {
    return (
      <PageShell title="Embed" subtitle="Unknown embedded app route.">
        <p className="text-sm text-zt-muted">No embed configuration for this path.</p>
      </PageShell>
    );
  }

  return (
    <PageShell
      title={config.title}
      subtitle="Full-height embedded view (internal dashboard only)."
    >
      <div className="mb-3 flex justify-end">
        <OpenInAppButton appId={config.appId} />
      </div>
      <div className="h-[calc(100vh-10rem)]">
        <AppEmbedFrame appId={config.appId} title={config.title} className="h-full" />
      </div>
    </PageShell>
  );
}

export default EmbedApp;
